import { render, staticRenderFns } from "./ChannelImgs.vue?vue&type=template&id=95fccdb8&scoped=true"
import script from "./ChannelImgs.vue?vue&type=script&lang=js"
export * from "./ChannelImgs.vue?vue&type=script&lang=js"
import style0 from "./ChannelImgs.vue?vue&type=style&index=0&id=95fccdb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fccdb8",
  null
  
)

export default component.exports